module.exports = __webpack_public_path__ + "static/media/20210410_212806_191_IMG_0412.e1eac16e.jpg";